__webpack_require__.p = "/FashIntell/";